module.exports = __webpack_public_path__ + "img/icn_instruction.ed8b3150.svg";